<template>
    <section class="about-header section-bg-3"><!---- :style="{ marginTop: activePromotion ? '0' : '64px' }" -->
    <div class="container">
      <h1>Terms and Conditions</h1>
    </div>
  </section>

    <section class="container mt-25 pt-40">
        <div class="tabs-container">
            <ul class="tabs">
                <li v-for="tab in tabs" :key="tab.id" :class="{ active: tab.id === activeTab }"
                    @click="activeTab = tab.id">
                    {{ tab.name }}
                </li>
            </ul>

            <div class="tab-content">
                <section v-if="activeTab === 'terms-of-use'">
                    <h2>Terms of Use</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem quisquam ullam, optio ducimus
                        nulla saepe deserunt atque magni consectetur fugit laudantium fuga nam hic, reprehenderit ipsum,
                        amet excepturi recusandae voluptate!</p>
                </section>

                <section v-if="activeTab === 'privacy-policy'">
                    <h2>Privacy Policy</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem quisquam ullam, optio ducimus
                        nulla saepe deserunt atque magni consectetur fugit laudantium fuga nam hic, reprehenderit ipsum,
                        amet excepturi recusandae voluptate!</p>
                </section>

                <section v-if="activeTab === 'business-privacy'">
                    <h2>Udemy Business Privacy Statement</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem quisquam ullam, optio ducimus
                        nulla saepe deserunt atque magni consectetur fugit laudantium fuga nam hic, reprehenderit ipsum,
                        amet excepturi recusandae voluptate!</p>
                </section>
            </div>

        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            activeTab: 'terms-of-use',
            tabs: [
                { id: 'terms-of-use', name: 'Terms of Use' },
                { id: 'privacy-policy', name: 'Privacy policy' },
                { id: 'business-privacy', name: 'Udemy Business Privacy Statement' },
                /*{ id: 'intellectual-property', name: 'Intellectual Property Policy' },
                { id: 'api-agreement', name: 'Udemy API Agreement' },
                { id: 'services-agreement', name: 'Master Services Agreement' },
                { id: 'instructor-terms', name: 'Instructor Terms' },
                { id: 'affiliate-terms', name: 'Affiliate Terms & Conditions' },
                { id: 'leadership-academy', name: 'Udemy Business Leadership Academy Terms & Conditions' },*/
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.tabs-container {
    display: flex;
    flex-direction: row;
    min-height: 50vh;
}

.tabs {
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #d4eff8;
    display: flex;
    flex-direction: column;
    width: 500px;

    li {
        padding: 15px 25px;
        cursor: pointer;
        background-color: #f9f9f9;
        border-bottom: 1px solid #d4eff8;
        transition: background-color 0.3s ease;
        color: var(--Primary-600, #09445D);
        font-size: 18px;
        &:hover {
            background-color: #e4f6fd99;
        }

        &.active {
            background-color: #fff;
            font-weight: 600;
            border-right: 3px solid #0e6f99;
        }
    }
}

.tab-content {
    padding: 15px 40px;
    flex-grow: 1;
    background-color: #fff;
    border: 1px solid #d4eff8;
   &:lang(en){
    border-left: none;
   }
   &:lang(ar){
    border-right: none;
   }
}
section{
    h2{
        color: var(--Primary-600, #09445D);
        font-size: 32px;
        font-weight: 700;
        line-height: 140%;
        margin-bottom: 20px;
    }
    p{
        color: var(--Neutral-600, #666);
        font-size: 16px;
        font-weight: 400;
        line-height: 140%; 
    }
}

@media screen and (max-width: 768px){
    .tabs-container{flex-direction: column;}
    .tab-content{
        border: none;
    }
    .tabs{
        border-radius: 8px;
        flex-direction: row;
        overflow-x: scroll;
        width: 100%;
        margin-bottom: 30px;
        li{
            font-size: 15px;
            white-space: nowrap;
          
        }
        /* Style the scrollbar track */
            &::-webkit-scrollbar-track {
            background: #f0f0f0; 
            border-radius: 5px; 
            }
            /* Style the scrollbar thumb */
            &::-webkit-scrollbar-thumb {
            background: #7c929b; /* Thumb color */
            border-radius: 10px;
            border: 2px solid #f0f0f0;
            }
            /* Style the scrollbar thumb when hovered */
            &::-webkit-scrollbar-thumb:hover {
            background: #0778a6; /* Thumb color when hovered */
            }
            /* Set the scrollbar width */
            &::-webkit-scrollbar {
            width: 12px; /* Vertical scrollbar width */
            }
    }
}
</style>